import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CoreEnum } from 'Models';

export interface ReviewerProfileModel {
  id: string;
  firstName?: string;
  lastName?: string;
  status?: CoreEnum;
  preferredMeansOfContact?: CoreEnum;
  contactNumber?: string;
  mobileNumber?: string;
  contactPerson?: string;
  isOnHold?: boolean;
  isProfileComplete?: boolean;
  followupDate?: string;
}

export const DEFAULT_REVIEWER_PROFILE: ReviewerProfileModel = {
  id: '',
};

const ReviewerProfileSections = {
  // TODO: define sections once designs are provided
};

export const ReviewerProfileSchema = Yup.object().shape({
  id: Yup.string().nullable(),
  // TODO: add field validations once designs are provided
});

type UseReviewerProfileFormProps = {
  onSubmit: (values: ReviewerProfileModel) => void;
  reviewer?: ReviewerProfileModel | null;
};

export const useReviewerProfileForm = ({
  onSubmit,
  reviewer,
}: UseReviewerProfileFormProps) => {
  const formik = useFormik<ReviewerProfileModel>({
    enableReinitialize: true,
    initialValues: reviewer ?? DEFAULT_REVIEWER_PROFILE,
    validationSchema: ReviewerProfileSchema,
    onSubmit,
    validateOnMount: true,
  });

  return formik;
};
